<template>
  <b-card :no-body="true">
    <div slot="header">
      <b-row>
        <b-col class="col-12 col-md-6 d-flex align-items-center">
          <div>
            <strong>
              {{ $lang.audiunce_info }}
              <ProfileBoxPopupWrapper
                :data="audience"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
              <b-badge
                v-if="
                  +pathOr(false, ['parvandeh_status', 'id'], audience) !== 1
                "
                pill
                variant="danger"
                class="ml-2 fs_14"
                >{{
                  pathOr(false, ["parvandeh_status", "caption"], audience)
                }}</b-badge
              >
            </strong>
          </div>
        </b-col>
        <b-col class="col-12 col-md-6">
          <div class="float-right">
            <!-- header-filter -->
            <b-button
              @click="isCollapsed = !isCollapsed"
              :class="isCollapsed ? 'btn-success ml-2' : 'btn-lightgray ml-2'"
            >
              <i
                :class="isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'"
              ></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-overlay :show="isOverlay" rounded="sm" :opacity="0.2">
      <b-collapse id="collapseSearchTable" :visible="isCollapsed" class="my-2">
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="text-center d-flex justify-content-center align-content-center"
          >
            <div class="image-audience">
              <b-img
                :src="img_kind"
                class="w-100"
                rounded="circle"
                @error="errorImg"
              />
            </div>
          </b-col>
          <b-col cols="12" md="8">
            <b-col cols="12" class="py-1"
              >{{ $lang.name }} {{ $lang.family }}: {{ audience.full_name }}
            </b-col>
            <b-col v-if="audience.birth_date" cols="12" class="py-1"
              >{{ $lang.year_birth }} :
              {{ pathOr("", ["birth_date", "jalali"], audience) }}</b-col
            >
            <b-col cols="12" class="py-1"
              >{{ $lang.marriage }} :
              {{ pathOr("", ["marriage", "caption"], audience) }}
            </b-col>
            <b-col v-if="audience.religion" cols="12" class="py-1"
              >{{ $lang.religion }}:
              {{ pathOr("", ["religion", "caption"], audience) }}
            </b-col>
            <b-col v-if="audience.allegiance" cols="12" class="py-1"
              >{{ $lang.allegiance }} : {{ audience.allegiance }}
            </b-col>

            <b-col v-if="audience.last_address" cols="12" class="py-1">
              {{ $lang.city_address }}:
              {{ pathOr("", ["last_address"], audience) }}</b-col
            >
            <b-col v-if="audience.biography" cols="12" class="py-1"
              >{{ $lang.biography }} : {{ audience.biography }}
            </b-col>
            <b-col v-if="audience.parvandehNumber" cols="12" class="py-1"
              >{{ $lang.researchLang.parvandeh_number }} :
              {{ audience.parvandehNumber }}
            </b-col>
            <b-col v-if="audience.termName" cols="12" class="py-1"
              >{{ $lang.researchLang.term_name }} : {{ audience.termName }}
            </b-col>
            <b-col v-if="audience.status_end_reason" cols="12" class="py-1"
              >{{ $lang.status_end_reason }}:
              {{ pathOr("", ["status_end_reason", "caption"], audience) }}
            </b-col>
            <b-col v-if="audience.interview_status" cols="12" class="py-1"
              >{{ $lang.interview_status }}:
              {{ audience.interview_status }}
            </b-col>
          </b-col>
        </b-row>
      </b-collapse>
    </b-overlay>
  </b-card>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import { pathOr } from "ramda";

export default {
  props: {
    audience: {
      type: Object,
      default: () => {},
    },
    img_kind: {
      type: String,
    },
  },
  data() {
    return {
      isCollapsed: false,
      isOverlay: false,
    };
  },
  methods: {
    pathOr,
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noPerson;
      }
    },
  },
  components: { ProfileBoxPopupWrapper },
};
</script>

<style>
.image-audience {
  width: 150px;
  height: 150px;
  display: block;
  margin: auto;
}
</style>
